<!--
 * @Description: 
 * @Date: 2022-09-30 14:52:52
 * @LastEditTime: 2026-04-21 18:11:45
-->
<template>
  <div class="login-module">
    <div class="over-z">
      <div class="top-title">
        <span>保际非遗网</span>
        <i @click="SET_MODULE_FLAG(false)" class="el-icon-close"></i>
      </div>
      <!-- <div class="tabs">
        <el-tabs
          v-if="tabIdx == 2 || tabIdx == 6"
          v-model="tabIdx"
          @tab-click="handleClick"
        >
          <el-tab-pane label="手机注册" :name="2"></el-tab-pane>
          <el-tab-pane label="谷歌邮箱注册" :name="6"></el-tab-pane>
        </el-tabs>
      </div> -->

      <el-form :model="loginForm" :rules="rules" ref="ruleForm">
        <el-form-item v-if="tabIdx != 5 && tabIdx != 6" prop="phone">
          <el-input
            v-model="loginForm.phone"
            placeholder="请输入账号或手机号"
            auto-complete="new-password"
            clearable
          >
            <img
              src="@/assets/loginModule/phone.png"
              class="phone-icon"
              slot="prepend"
            />
          </el-input>
        </el-form-item>
        <el-form-item v-if="tabIdx == 5 || tabIdx == 6" prop="email">
          <el-input
            v-model="loginForm.email"
            placeholder="请输入邮箱地址"
            auto-complete="new-password"
            clearable
          >
            <img
              src="@/assets/loginModule/google.png"
              class="phone-icon"
              slot="prepend"
            />
          </el-input>
        </el-form-item>
        <el-form-item v-if="tabIdx != 4" prop="verifyCode">
          <el-input
            v-model="loginForm.verifyCode"
            placeholder="请输入验证码"
            auto-complete="new-password"
          >
            <img
              src="@/assets/loginModule/code.png"
              class="phone-icon"
              slot="prepend"
            />
            <div @click="getCodeEvent" slot="append" class="get-code">
              {{ getCodeText }}
            </div>
          </el-input>
        </el-form-item>
        <el-form-item
          v-if="tabIdx != 1 && tabIdx != 5 && tabIdx != 6"
          prop="loginPassword"
        >
          <el-input
            v-model="loginForm.loginPassword"
            type="password"
            placeholder="请输入密码"
            auto-complete="new-password"
            clearable
          >
            <img
              src="@/assets/loginModule/password.png"
              class="phone-icon"
              slot="prepend"
            />
          </el-input>
        </el-form-item>
        <!-- <el-form-item v-if="tabIdx == 2 || tabIdx == 3" prop="agaPassword">
          <el-input
            v-model="loginForm.agaPassword"
            type="password"
            placeholder="请确认密码"
            auto-complete="new-password"
            clearable
          >
            <img
              src="@/assets/loginModule/sure.png"
              class="phone-icon"
              slot="prepend"
            />
          </el-input>
        </el-form-item> -->
        <div @click="submitHandler" class="reg-btn">{{ subText }}</div>
        <!-- <el-button type="primary" @click="submitHandler">登录</el-button> -->
        <div class="forget-password">
          <span @click="tabIdx = 3" class="forget-password">忘记密码</span>
        </div>
      </el-form>
      <div class="select-kind">
        <div class="left-box">
          <span @click="changeLoginWay" class="sp">{{ loginWay }}</span>
          <!-- <span @click="changeLoginWay2" class="sp" style="padding-left: 20px"
            >谷歌邮箱登录</span
          > -->
        </div>
        <span @click="tabIdx = 2" class="sp">创建账号</span>
      </div>

      <div class="notice_box">
        <div>温馨提示:</div>
        <div>(1)、实行收费制，每个月15元</div>
        <div>
          (2)、登录名、手机号是保际（北京）非物质文化遗产保护发展有限公司的唯一信息，其它账号不可以重复使用
        </div>
        <div>(3)、为了您的账号安全，请不要将账号信息告知他人</div>
      </div>
    </div>
    <!-- <el-dialog
      title="更新提示"
      :visible="versionFlag"
      width="30%"
      :before-close="handleClose"
    >
      <div v-html="versionInfo.updateContent" class="versionContent"></div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="SET_VERSION_FLAG(false)">取 消</el-button>
        <el-button type="primary" @click="handleSubmit"
          >前往更新</el-button
        >
      </span>
    </el-dialog> -->
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex'
import {
  userInfoRegisterApi,
  sendVerifyCodeApi,
  userEmailLoginApi,
  sendEmailVerifyCodeApi,
  userEmailRegisterApi,
} from '@/apis/userInfo'
import regRules from '@/utils/regForm'
export default {
  data() {
    return {
      tabIdx: 1, // 1: 验证码登录  2: 注册  3: 忘记密码 4: 密码登录 5:谷歌登录 6:谷歌注册 注--tabIdx是此组件的核心属性
      timer: null,
      getCodeText: '获取验证码',
      loginForm: {
        phone: '',
        loginPassword: '',
        agaPassword: '',
        verifyCode: '',
        email: '',
      },
      rules: regRules,
    }
  },
  computed: {
    ...mapState('user', {
      moduleFlag: (state) => state.moduleFlag,
      versionFlag: (state) => state.versionFlag,
      versionInfo: (state) => state.versionInfo,
    }),
    loginWay() {
      if (
        this.tabIdx === 2 ||
        this.tabIdx === 4 ||
        this.tabIdx === 5 ||
        this.tabIdx === 6
      ) {
        return '短信登录'
      } else {
        return '密码登录'
      }
    },
    subText() {
      if (this.tabIdx === 1 || this.tabIdx === 4) {
        return '立即登录'
      } else if (this.tabIdx === 2) {
        return '注册'
      } else if (this.tabIdx === 3) {
        return '修改密码'
      } else if (this.tabIdx === 5) {
        return '邮箱登录'
      } else if (this.tabIdx === 6) {
        return '邮箱注册'
      }
    },
  },
  watch: {
    tabIdx(newVal) {
      // 变化的时候所有的数据初始化
      this.$refs.ruleForm.clearValidate()
      clearInterval(this.timer)
      Object.assign(this.$data, this.$options.data())
      this.tabIdx = newVal
    },
    moduleFlag(newVal) {
      if (!newVal) this.tabIdx = 1
    },
  },
  created() {
    window.addEventListener('keydown', this.handkeyCode, true) //开启监听键盘按下事件
  },
  beforeDestroy() {
    window.removeEventListener('keydown', this.handkeyCode, true) //关闭监听键盘按下事件
  },
  methods: {
    handleClose() {
      store.commit('user/SET_VERSION_FLAG', false)
    },
    handleSubmit() {
      store.commit('user/SET_VERSION_FLAG', false)
      this.$router.push({
        path: '/user/userSettings',
        query: {
          tabsName: 'fourth',
        },
      })
    },
    handkeyCode(e) {
      if (e.keyCode === 13) {
        //触发登录/注册方法
        this.submitHandler()
      }
    },
    ...mapMutations('user', {
      SET_MODULE_FLAG: 'SET_MODULE_FLAG',
      SET_VERSION_FLAG: 'SET_VERSION_FLAG',
    }),
    ...mapActions('user', {
      login: 'login',
      codeLogin: 'codeLogin',
      changePassword: 'changePassword',
      emailLogin: 'emailLogin',
    }),
    changeLoginWay() {
      this.tabIdx = this.tabIdx === 1 ? 4 : 1
    },
    changeLoginWay2() {
      this.tabIdx = 5
    },
    submitHandler() {
      this.$refs.ruleForm.validate(async (valid) => {
        if (valid) {
          // if (this.tabIdx === 2 || this.tabIdx === 3) {
          //   const { password, agaPassword } = this.loginForm;
          //   if (password != agaPassword) {
          //     this.$message({
          //       type: "error",
          //       message: "密码与确认密码不一致！",
          //     });
          //     return;
          //   }
          // }
          if (this.tabIdx === 1) {
            // 密码登录
            this.codeLogin(this.loginForm)
          } else if (this.tabIdx === 3) {
            // 忘记密码
            const { phone, loginPassword, verifyCode } = this.loginForm
            this.changePassword({
              tel: phone,
              verifyCode,
              newPassword: loginPassword,
            })
          } else if (this.tabIdx === 4) {
            // 验证码登录
            this.login(this.loginForm)
          } else if (this.tabIdx === 2) {
            // 注册
            const res = await userInfoRegisterApi(this.loginForm)
            if (res && res.message == 'success') {
              this.tabIdx = 1
              this.$message({
                type: 'success',
                message: '注册成功，快去登录吧！',
              })
            }
          } else if (this.tabIdx === 5) {
            const obj = {
              email: this.loginForm.email,
              verifyCode: this.loginForm.verifyCode,
            }
            this.emailLogin(obj)
          } else if (this.tabIdx === 6) {
            const obj = {
              email: this.loginForm.email,
              verifyCode: this.loginForm.verifyCode,
            }
            const res = await userEmailRegisterApi(obj)
            if (res && res.message == 'success') {
              this.tabIdx = 1
              this.$message({
                type: 'success',
                message: '注册成功，快去登录吧！',
              })
            }
          }
        }
      })
    },
    getCodeEvent() {
      if (this.tabIdx != 5 && this.tabIdx != 6) {
        this.$refs.ruleForm.validateField('phone', async (e) => {
          if (e || this.getCodeText != '获取验证码') {
            return
          }
          this.getCodeText = '请稍等'
          const res = await sendVerifyCodeApi({
            phone: this.loginForm.phone,
          }).catch(() => (this.getCodeText = '获取验证码'))
          if (res && res.message == 'success') {
            this.tampTime()
            this.$message({
              type: 'success',
              message: '发送成功！',
            })
          }
        })
      } else {
        this.$refs.ruleForm.validateField('email', async (e) => {
          if (e || this.getCodeText != '获取验证码') {
            return
          }
          this.getCodeText = '请稍等'
          const res = await sendEmailVerifyCodeApi({
            email: this.loginForm.email,
          }).catch(() => (this.getCodeText = '获取验证码'))
          if (res && res.message == 'success') {
            this.tampTime()
            this.$message({
              type: 'success',
              message: '发送成功！',
            })
          }
        })
      }
    },
    tampTime() {
      // 验证码倒计时
      let tempStr = 60
      this.getCodeText = 60 + 's后可发送'
      this.timer = setInterval(() => {
        if (tempStr <= 0) {
          this.getCodeText = '获取验证码'
          clearInterval(this.timer)
          return
        }
        tempStr--
        if (tempStr < 10) {
          this.getCodeText = '0' + tempStr + 's后可发送'
        } else {
          this.getCodeText = tempStr + 's后可发送'
        }
      }, 1000)
    },
  },
}
</script>
<style lang="scss" scoped>
.tabs {
  display: flex;
  justify-content: center;
  align-items: center;
}

.notice_box {
  padding: 20px 80px;
  color: #999;
  font-size: 14px;
}
</style>
<style lang="scss" scoped>
.login-module {
  position: fixed;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;
  z-index: 99;

  .over-z {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translateX(-50%) translateY(-50%);
    width: 550px;
    z-index: 999;
    padding-bottom: 55px;
    user-select: none;
    background: #fff;
    box-shadow: 0px 1px 0px 1px rgba(0, 0, 0, 0.2);

    .top-title {
      display: flex;
      align-items: center;
      justify-content: space-between;
      color: #fff;
      height: 60px;
      padding: 0 30px;
      line-height: 60px;
      font-size: 18px;
      background: #c44004;

      i {
        cursor: pointer;
        font-size: 26px;
      }
    }

    .el-form {
      width: max-content;
      margin: 0 auto;
      margin-top: 40px;

      .el-input {
        width: 400px;
      }

      .phone-icon {
        width: 15px;
      }

      .get-code {
        height: 38px;
        padding: 0 5px;
        line-height: 38px;
      }

      .reg-btn {
        cursor: pointer;
        color: #fff;
        padding: 9px 0;
        letter-spacing: 3px;
        border-radius: 4px;
        text-align: center;
        margin-bottom: 10px;
        background: #c44004;
      }

      .forget-password {
        cursor: pointer;
        display: flex;
        justify-content: flex-end;
        color: #999;
      }
    }

    .select-kind {
      position: absolute;
      display: flex;
      justify-content: space-between;
      width: 100%;
      padding: 10px 20px;
      bottom: 0;
      color: #c44004;
      box-sizing: border-box;

      .sp {
        cursor: pointer;
        letter-spacing: 2px;
      }
    }
  }
}
</style>

<style lang="scss" scoped>
::v-deep .el-input-group__append {
  cursor: pointer;
  padding: 0;
}

::v-deep .el-input-group__prepend {
  padding: 0 15px;
}
</style>
